import styled from 'styled-components';
import { __ } from '../../../locales';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GameCountDown = styled.div`
  font-size: ${window.innerWidth / 25}px;
  margin-top: ${window.innerWidth / 21}px;
  color: white;
`;

const BeforeGameCountDown = styled.div`
  font-size: 12.5vw;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
`;

const Circle = styled.div`
  height: 23vw;
  width: 23vw;
  border-radius: 50%;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -60%);
  border: 8px solid white;
`;

const ReadySetGo = styled.h1`
  font-size: 12.5vw;
  position: fixed;
  color: white;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
`;

const Hint = styled.p`
  text-align: center;
  width: 86%;
  font-size: 3vh;
  line-height: 1.5em;
  position: fixed;
  color: white;
  left: 50%;
  top: 62%;
  transform: translate(-50%, -40%);
`;

/**
 * This compoent is used for two different parts:
 *
 * The first part is for shwoing 5 seconds count down timer of the top right of the game's page
 *
 * The seond part is for showing 5 seconds count down timer before start of the game with
 * context of Ready, Set, Go!
 *
 */

const SecondsCounter = ({ seconds, isBeforeGame }) => (
  <Container>
    {!isBeforeGame && (
      <GameCountDown role="timer">
        {'00:'}
        {seconds}
      </GameCountDown>
    )}
    {isBeforeGame && (
      <>
        <Circle>
          <BeforeGameCountDown role="timer">
            {seconds}
          </BeforeGameCountDown>
        </Circle>
        <Hint>{__('app.answer_less_than_five_seconds')}</Hint>
      </>
    )}
    {isBeforeGame && seconds === '02' && (
      <ReadySetGo>{__('app.ready')}</ReadySetGo>
    )}
    {isBeforeGame && seconds === '01' && (
      <ReadySetGo>{__('app.set')}</ReadySetGo>
    )}
    {isBeforeGame && seconds === '00' && (
      <ReadySetGo>{__('app.go')}</ReadySetGo>
    )}
  </Container>
);

export default SecondsCounter;
